<template>
    <div id="wrapper">
        <Director-Bar index="6"></Director-Bar>
  
      <div id="content-wrapper">
        <div class="container-fluid">
          <div class="row">
            <div class="col-3">
              <b-table
                bordered
                head-variant="dark"
                hover
                responsive
                :fields="fields"
                selectable
                select-mode="single"
                :items="items"
                @row-selected="onRowSelected"
                table-variant="light"
              >
                <template v-slot:cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
              </b-table>
            </div>
            <div class="col-5">
              <b-table
                bordered
                head-variant="dark"
                hover
                responsive
                :fields="fieldsPermissionGroups"
                :items="permission_groups"
                @row-selected="onPermissionGroupRowSelected"
                selectable
                select-mode="single"
                table-variant="light"
              >
                <template v-slot:cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
              </b-table>
            </div>
            <div class="col-4">
              <b-table
                bordered
                head-variant="dark"
                hover
                responsive
                :fields="fieldsActivity"
                :items="permissionsByGroup"
                table-variant="light"
              >
                <template v-slot:cell(hasPermission)="data">
                  <!-- <input
                    type="checkbox"
                    v-model="data.item.hasPermission"
                    @change.prevent="updatePermissionInRole(data)"
                    :disabled="!hethong_update"
                  /> -->
                  <input
                    type="checkbox"
                    v-model="data.item.hasPermission"
                    @change.prevent="updatePermissionInRole(data)"                  
                  />
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <!-- /.container-fluid -->
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import DirectorBar from "../Bonus/Bonus_Bar.vue";
  export default {
    name: "Permissions",
    components: {
        DirectorBar,
    },
    computed: {

      permissionsByGroup() {
        if (
          this.item_selected != null &&
          this.permission_groups_selected != null
        ) {
          let result = [];
          const vm = this;
          this.permissions.forEach(function(permission) {          
            if (permission.permissionGroupId == vm.permission_groups_selected[0].id) {            
              result.push(permission);            
            }
          });  
          return result;     
        }
        return [];
      },
    },
    data() {
      return {
        items: [],
        item_selected: null,
        permissions: [],
        permission_groups: [],
        permission_groups_selected: null,
        //table
        fields: [
          {
            key: "selected",
            label: "",
            thStyle: { width: "50px !important" },
          },
          {
            key: "name",
            label: "Groups",
          },
        ],
        //table permission group
        fieldsPermissionGroups: [
          {
            key: "selected",
            label: "",
            thStyle: { width: "50px !important" },
          },
          {
            key: "name",
            label: "Funtions",
          },
        ],
        //table permission
        fieldsActivity: [
          {
            key: "hasPermission",
            label: "",
            thStyle: { width: "100px !important" },
          },
          {
            key: "name",
            label: "Permissions",
          },
        ],
      };
    },
    beforeRouteEnter(to, from, next) {
      axios
        .all([axios.get("/api/Bonus/BonusIndex"), axios.get("/api/Bonus/PerBonusIndex")])
        .then(
       axios.spread((role, permission_groups) => {
            next((vm) =>
              vm.initData(role.data.items, permission_groups.data.items)
            );
          })
        );
    },
    methods: {
      initData(items, permission_groups) {
        this.items = items;
        this.permission_groups = permission_groups;
      },
      onRowSelected(item) {
        if (item.length == 0) {
          this.item_selected = null;
        } else {
          this.item_selected = item;
          this.getPermissionsByRole();
        }
      },
      onPermissionGroupRowSelected(item) {
        if (item.length == 0) {
          this.permission_groups_selected = null;
        } else {
          this.permission_groups_selected = item;
        }
      },
      getPermissionsByRole() {
        if (this.item_selected == null) {
          this.permissions = [];
          return;
        }
        axios
          .get(`/api/role/${this.item_selected[0].id}/permission`)
          .then((res) => {
            this.permissions = res.data.items;
          })
          .catch((err) => {
            this.permissions = [];
            this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          });
      },
      updatePermissionInRole(data) {
        if (this.item_selected == null) {
          return;
        }
        axios
          .put(`/api/role/${this.item_selected[0].id}/permission`, {
            id: data.item.id,
            hasPermission: data.item.hasPermission,
          })
          .then((res) => {})
          .catch((err) => {
            this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          });
      },
    },
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  </style>
  